/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from 'react';
import CloseButton from '../Buttons/CloseButton';
import TypeWriter from './TypeWriter';
import { applyGlossariesToPage } from '../../store/Document/documentActions';
import {
  USER,
  defineApplicableGlossaries,
  displayDocVersion,
  extractTextContent,
  notification,
} from '../../assets/constants/strings';
import { connect } from 'react-redux';
import $ from 'jquery';
import Loader from '../Loader';
import ShareButton from '../ShareButton/';
import { UpdateUserUsage } from '../../store/User/userActions';

const mapStateToProps = (state) => ({
  glossaries: state.client.glossaryList,
  page: state.document.currentPage,
  isPreview: state.client.isPreview,
  currentDocument: state.document.currentDocument,
  user: state.user.user,
});

const connector = connect(mapStateToProps, { UpdateUserUsage });

const RevealrSummary = ({
  currentDoc,
  handleCloseSummary,
  glossaries,
  handleDisplayGlossary,
  page,
  isPreview,
  currentDocument,
  user,
  UpdateUserUsage,
}) => {
  const { summary } = currentDoc;
  const [treatedHTML, setTreatedHTML] = useState(summary);
  const [loading, setLoading] = useState(false);
  const [applicableGlossaries, setApplicableGlossaries] = useState(null);
  const [typingStarted, setTypingStarted] = useState(false);
  const [typingFinished, setTypingFinished] = useState(false);

  const HTMLContent = summary;
  const [previewHTML, setPreviewHTML] = useState(HTMLContent);

  useEffect(() => {
    if (user.remainingSummaries < 0) {
      return notification(
        'info',
        'You have reached your amount of summaries for the current period.'
      );
    } else {
      UpdateUserUsage(USER.USAGE.SUMMARIES);
    }
  }, []);

  useEffect(() => {
    if (!isPreview) {
      if (page && glossaries) {
        setLoading(true);

        // tab title
        if (
          currentDocument &&
          (!document.title.match('RegulationCity') ||
            !document.title.match(currentDocument.title))
        ) {
          document.title = displayDocVersion(currentDocument)
            ? displayDocVersion(currentDocument) + ' | RegulationCity'
            : 'RegulationCity';
        }

        // apply glossaries that relate to this page
        setTreatedHTML(applyGlossariesToPage(glossaries, HTMLContent));

        // get list of applicable glossaries to add click event listeners
        setApplicableGlossaries(defineApplicableGlossaries(glossaries));

        setLoading(false);
      } else setLoading(true);
    } else {
      if (glossaries)
        setPreviewHTML(applyGlossariesToPage(glossaries, HTMLContent));
    }
  }, [glossaries, page]);

  useEffect(() => {
    addGlossaryListeners(isPreview ? previewHTML : treatedHTML);
    $('[data-toggle="tooltip"]').tooltip();
  });

  const addGlossaryListeners = (enhancedHTML) => {
    if (
      page !== null &&
      glossaries !== null &&
      applicableGlossaries !== null &&
      applicableGlossaries.length > 0
    ) {
      applicableGlossaries.forEach((glossary) => {
        if (
          glossary.Content.filter((item) => item.Definition.length >= 275)
            .length > 0
        ) {
          const { Content } = glossary;
          Content.filter((item) => item.Definition.length >= 275).forEach(
            (item) => {
              const key = item.Key;
              if (enhancedHTML.match(`MODAL_${key}`)) {
                document.getElementById(`MODAL_${key}`) &&
                  document
                    .getElementById(`MODAL_${key}`)
                    .addEventListener('click', () =>
                      handleDisplayGlossary(glossary.ID, key)
                    );
              }
            }
          );
        }
      });
    }
  };

  const handleTypingStart = () => {
    setTypingStarted(true);
    console.log('Typing started');
  };

  const handleTypingFinish = () => {
    setTypingFinished(true);
    console.log('Typing finished');
  };

  return (
    <div className='d-flex flex-column main-content-wrapper'>
      <div className='d-flex justify-content-between mb-3'>
        <ShareButton
          currentDocument={currentDoc}
          user={user}
          isSummary={true}
        />
        {/* <h2 className='d-flex mr-0' id='close-summary'>
          <CloseButton
            handleClose={handleCloseSummary}
            title='Return to Document'
          />
        </h2> */}
      </div>
      <p id='disclaimer-text'>
        <b>
          <i>This is Beta release of Summarisation using Generative Ai.</i>
        </b>
      </p>
      <div className='row m-0 p-0' id='main-content'>
        {summary && !loading ? (
          <TypeWriter
            text={treatedHTML}
            delay={1}
            onStartTyping={handleTypingStart}
            onFinishTyping={handleTypingFinish}
          />
        ) : (
          <Loader text='Generating Summary...' />
        )}
      </div>
    </div>
  );
};

export default connector(RevealrSummary);
